<template>
  <div
    v-can="'show-billing-details'"
    class="tooltip-wrapper"
  >
    <span
      :id="circleId"
      ref="circle"
      class="blinking circle"
      @click="showTooltip = true"
    />

    <b-tooltip
      v-if="showTooltip"
      :target="circleId"
      :variant="billing_city_enabled ? 'success' : 'danger'"
      html
      triggers=""
      placement="top"
      boundary="window"
      custom-class="my-tooltip"
      show
    >
      <div class="d-flex justify-content-center align-items-center">
        <div>
          <feather-icon
            class="bell-icon"
            :style="{ backgroundColor: billing_city_enabled ? '#28a745' : '#891B3C' }"
            icon="BellIcon"
            size="30"
          />
        </div>
        <div class="tooltip-content ml-1">
          <strong>Note</strong> :
          {{ tooltipText }}
        </div>
        <b-button
          variant="link"
          class="close-btn ml-2"
          :style="{ backgroundColor: billing_city_enabled ? '#28a745' : '#891B3C' }"
          @click.stop="showTooltip = false"
        >
          ✕
        </b-button>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import {
  BTooltip, BButton,
} from 'bootstrap-vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const OrderSettingsRepository = RepositoryFactory.get('orderSetting')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  name: 'MyBlinkingTooltip',
  components: {
    BTooltip,
    BButton,
  },
  data() {
    return {
      billing_city_enabled: false,
      billing_city_id: null,
      cityName: '',
      showTooltip: false,
    }
  },
  computed: {
    // generate a unique id for this instance
    circleId() {
      // eslint-disable-next-line no-underscore-dangle
      return `blink-circle-${this._uid}`
    },
    tooltipText() {
      if (this.billing_city_enabled) {
        return `Billing city override is ON. Rates will now be calculated from ${this.cityName} to the customer's destination city. Hope your rate cards are set with ${this.cityName} as the origin.`
      }
      return 'Billing city override is OFF. Rates will now be calculated from the Merchant\'s Origin City to the Customer\'s Destination City. Hope your rate cards are set with your merchant origin cities as the origins.'
    },
  },
  async created() {
    await this.readOrderSetting()
    await this.getCityList()
  },
  methods: {
    async readOrderSetting() {
      try {
        const orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(orderSettings))
        this.billing_city_enabled = orderSettings.billing_setting.billing_city_enabled
        this.billing_city_id = orderSettings.billing_setting.billing_city_id
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getCityList() {
      try {
        const cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityDropdownListNoFilter()).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(cityOptions))
        const city = cityOptions.find(c => c.id === this.billing_city_id)
        this.cityName = city ? city.name : '…'
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>

  <style scoped>
  /* make it blink */
  @keyframes blink {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0; }
  }
  .blinking {
    animation: blink 1s ease-in-out infinite;
  }

  /* size & color of the circle */
  .circle {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: yellow;
    cursor: pointer;
  }

  .tooltip-wrapper {
    margin-right: 20px;
    margin-top: 3px;
  }

  .bell-icon {
    border-radius: 50%;
    padding: 5px;
  }
  .tooltip-content {
    text-align: justify;
  }
  .close-btn {
    font-size: 0.5rem;
    color: white;
    text-shadow: none;
    border-radius: 50%;
    padding: 0.2rem 0.2rem;
  }
  </style>
